import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import kebabCase from 'lodash/kebabCase.js';
import PendoButton from '../../components/button/pendo-button.vue.js';
import PendoCard from '../../components/card/pendo-card.vue.js';
import PendoChooserGrid from '../../components/chooser-grid/pendo-chooser-grid.vue.js';
import PendoLayoutPreview from './pendo-layout-preview.vue.js';
import PendoModal from '../../components/modal/pendo-modal.vue.js';
import PendoTag from '../../components/tag/pendo-tag.vue.js';
import PendoTooltip from '../../directives/tooltip/pendo-tooltip.js';
import PendoPopover from '../../components/popover/pendo-popover.vue.js';
import { elementHasOverflowX } from '../../utils/dom.js';

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
var script = {
  name: 'PendoLayoutGrid',
  components: {
    PendoCard,
    PendoChooserGrid,
    PendoLayoutPreview,
    PendoButton,
    PendoModal,
    PendoTag,
    PendoPopover
  },
  directives: {
    PendoTooltip
  },
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: null
    },
    layouts: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    allowActions: {
      type: Object,
      default: () => ({})
    },
    filters: {
      type: [Object, Array],
      default: () => [{
        prop: ['title', 'subtitle'],
        value: ''
      }]
    },
    collapsible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDeleteLayoutModal: false,
      layoutToDelete: null,
      selectedLayout: null,
      dataCy: kebabCase(`${this.title} Layouts`),
      titleTooltipContent: null
    };
  },
  computed: {
    formattedLayouts() {
      const {
        loading,
        layouts,
        disabled,
        selectedLayout
      } = this;
      if (loading && !layouts.length) {
        return Array(8).fill({
          disabled: true,
          loading: true
        });
      }
      return layouts.map(layout => {
        const id = layout.id || kebabCase(layout.name);
        return _objectSpread2(_objectSpread2({}, layout), {}, {
          id,
          title: layout.name,
          subtitle: layout.subtext || 'Pendo Default',
          disabled: loading || layout.loading || disabled || !layout.active,
          loading: loading || layout.loading,
          selected: selectedLayout ? selectedLayout.id === id : false,
          tooltipOptions: _objectSpread2(_objectSpread2({}, layout.tooltipOptions), {}, {
            content: layout.active ? null : layout.tooltipOptions && layout.tooltipOptions.content
          })
        });
      });
    }
  },
  mounted() {
    this.checkTitleOverflow();
  },
  methods: {
    checkTitleOverflow: _async(function () {
      const _this = this;
      const elementHasOverflow = elementHasOverflowX(_this.$refs.title);
      if (elementHasOverflow) {
        _this.titleTooltipContent = _this.title;
      }
      return _await();
    }),
    handleLayoutSelect(layout) {
      this.selectedLayout = layout;
      this.$emit('select-layout', layout);
      this.$emit('onChooseLayout', layout);
    },
    handleLayoutDelete(layout) {
      this.layoutToDelete = layout;
      this.showDeleteLayoutModal = true;
    },
    cancelDelete() {
      this.layoutToDelete = null;
      this.showDeleteLayoutModal = false;
    },
    confirmDelete() {
      this.$emit('delete-layout', this.layoutToDelete);
      this.$emit('onDeleteLayout', this.layoutToDelete);
      this.layoutToDelete = null;
      this.showDeleteLayoutModal = false;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-layout-grid.vue2.js.map
